
































import Vue from 'vue'
import EntitlementsForm from '../components/EntitlementsForm.vue'
import { fetchEntitlementById, updateEntitlement, fetchEntitlementTypesList } from '../services/inventory-client'
import { EntitlementCreateData, EntitlementShowData, EntitlementTypeData } from '../types'

export default Vue.extend({
  name: 'EntitlementsEdit',
  components: {
    EntitlementsForm
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      isLoading: false,
      entitlement: {
        codename: '',
        type: '',
        subtype: '',
        max_count: 0,
        behaviors: []
      },
      showForm: false,
      entitlementTypesList: []
    }
  },
  mounted () {
    this.isLoading = true
    this.$store.commit('global/setLoading', true)

    this.fetchData()
  },
  methods: {
    async fetchData () {
      await fetchEntitlementById(this.id)
        .then((entitlement: EntitlementShowData) => {
          Vue.set(this, 'entitlement', {
            codename: entitlement.codename,
            type: entitlement.type,
            subtype: entitlement.subtype,
            behaviors: entitlement.behaviors,
            max_count: entitlement.max_count,
            available_since: entitlement.available_since || '',
            available_until: entitlement.available_until || '',
            stack_size: entitlement.stack_size || 0,
            properties: entitlement.properties || null,
            items: entitlement.items || [],
            currencies: entitlement.currencies || {}
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.$store.commit('global/setLoading', false)
        })

      await fetchEntitlementTypesList(``)
        .then((items: Array<EntitlementTypeData>) => {
          items.forEach((item: EntitlementTypeData, index: number) => {
            Vue.set(this.entitlementTypesList, index, item)
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.showForm = true
          this.isLoading = false
          this.$store.commit('global/setLoading', false)
        })
    },
    onSubmit (entitlement: EntitlementCreateData) {
      this.isLoading = true
      updateEntitlement(entitlement, this.id)
        .then(() => {
          this.clear()
          this.$store.commit('global/addNotification', {
            text: `You successfully edited entitlement!`,
            type: 'success'
          })
          this.fetchData()
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clear () {
      this.$validator.reset()
    }
  }
})
